const cloudName = "drbvhl8uu";
const uploadPreset = "customization_form_website";

const fileInput = document.getElementById("image_upload");
const hiddenInput = document.getElementById("cloudinary_image_url");
const submitBtn = document.getElementById("submitBtn");

if (!fileInput) return;

const form = fileInput.closest("form");
let isUploading = false;

fileInput.addEventListener("change", async function () {
    const file = this.files[0];

    if (!file) {
      hiddenInput.value = "";
      return;
    }

    const maxSizeInBytes = 5 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      alert("Image is too large. Please select a file smaller than 5MB.");
      fileInput.value = "";
      hiddenInput.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset);

    isUploading = true;
    submitBtn.innerText = "Uploading image...";
    submitBtn.disabled = true;

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
        { method: "POST", body: formData }
      );

      const data = await response.json();

      if (data.secure_url) {
        hiddenInput.value = data.secure_url;
        submitBtn.innerText = "Connect with our Cake Expert";
        submitBtn.disabled = false;
        isUploading = false;
      } else {
        throw new Error(data.error?.message || "Upload failed");
      }

    } catch (error) {
      console.error(error);
      alert("Image upload failed. Please check your connection and try again.");
      fileInput.value = "";
      hiddenInput.value = "";
      submitBtn.innerText = "Connect with our Cake Expert";
      submitBtn.disabled = false;
      isUploading = false;
    }
  });

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    if (isUploading) {
      alert("Please wait for the image upload to complete.");
      return;
    }

    if (!hiddenInput.value) {
      alert("Please upload an image first.");
      return;
    }

    submitBtn.innerText = "Saving your order...";
    submitBtn.disabled = true;

    const sheetData = {
      name: form.querySelector('[name="contact[name]"]').value,
      phone: form.querySelector('[name="contact[phone]"]').value,
      email: form.querySelector('[name="contact[email]"]').value,
      message: form.querySelector('[name="contact[body]"]').value,
      imageUrl: hiddenInput.value
    };

    const googleAppScriptUrl = "https://script.google.com/macros/s/AKfycbzl8jOJ1QLyzmFegjyM4fBQr4HLlvnz6BOatV6BL7qkifgPD7Ra54raEB71DCcUtGhGRA/exec";

    try {
      await fetch(googleAppScriptUrl, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(sheetData)
      });
    } catch (error) {
      console.error("Google Sheets backup failed", error);
    }

    form.submit();
  });